import { useQueries, useQuery } from "@tanstack/react-query";

import { getGridDataCount, getRawReviewReportData, getReviewReportDistributionData } from "../services";

// TO DO: variables verification. Conditonally call api based on variables.
// In this case we only want to call api if summarizeBy is not empty.
export const useGetRawReviewReportData = (variables, canViewVisualizations = false) => {
	const queries = variables.map((variable) => {
		const { summarizeBy } = variable;
		let isQueryEnabled = true;
		if (summarizeBy.length === 0 || !canViewVisualizations) {
			isQueryEnabled = false;
		}
		return {
			queryKey: ["getRawReviewReportData", variable],
			queryFn: () => getRawReviewReportData(variable),
			enabled: isQueryEnabled,
		};
	});
	return useQueries({ queries });
};

export const useGetGridDataCount = (variables) => {
	return useQuery({
		queryKey: ["getGridDataCount", variables],
		queryFn: () => getGridDataCount(variables),
	});
};

export const useGetReviewReportDistributionData = (variables) => {
	const queries = variables.map((variable) => {
		const { summarizeBy } = variable;
		let isQueryEnabled = true;
		if (summarizeBy.length === 0) {
			isQueryEnabled = false;
		}
		return {
			queryKey: ["getReviewReportDistributionData", variable],
			queryFn: () => getReviewReportDistributionData(variable),
			enabled: isQueryEnabled,
		};
	});
	return useQueries({ queries });
};
